var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.getClass(),attrs:{"src":_vm.src,"srcset":_vm.srcset,"sizes":_vm.sizes,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }